import { cx } from 'emotion';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ListItem from '@ublend-npm/aulaui-next-web/ListItem';

import MaterialVisibilityToggle from './MaterialVisibilityToggle.container';
import { listItem, hiddenListItem } from './MaterialListItem.styled';
import { sectionItem, selectedListItem } from './SectionListItem.styled';
import { useDrag, useDrop } from './MaterialListItem.dnd';

const CLASSES = { text: 'label' };

const SectionListItem = (props) => {
  const {
    materialId,
    hidden,
    parent,
    isInstructor,
    selected,
    onReorder,
    educatorOnly,
    ...otherProps
  } = props;
  const listItemRef = useRef(null);
  const dragDropProps = { ...props, isFolder: false };
  const [{ isDragging }, drag] = useDrag(dragDropProps);
  const [{ dropType }, drop] = useDrop(dragDropProps, listItemRef);

  drag(drop(listItemRef));
  return (
    <li ref={listItemRef}>
      <ListItem
        component="div"
        textTruncate
        className={cx(
          listItem,
          sectionItem,
          hidden && hiddenListItem,
          selected && selectedListItem
        )}
        classes={CLASSES}
        rightDecoration={
          isInstructor && !educatorOnly ? (
            <MaterialVisibilityToggle materialId={materialId} />
          ) : null
        }
        isDraggable
        isDragging={isDragging}
        dropType={dropType}
        attributes={{ 'aria-current': selected && 'page' }}
        {...otherProps}
      />
    </li>
  );
};

SectionListItem.propTypes = {
  materialId: PropTypes.string.isRequired,
  hidden: PropTypes.bool.isRequired,
  parent: PropTypes.string,
  isInstructor: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  onReorder: PropTypes.func.isRequired,
  educatorOnly: PropTypes.bool,
};

SectionListItem.defaultProps = {
  parent: null,
  educatorOnly: false,
};

export default React.memo(SectionListItem);
